import { createAddJackpotModal } from 'features/add-jackpot';
import { createBlockJackpotModal } from 'features/block-jackpot';
import { createDeleteJackpotModal } from 'features/delete-jackpot';
import { createEditJackpotModal } from 'features/edit-jackpot';
import { createUnblockJackpotModal } from 'features/unblock-jackpot';
import { createJackpotRegistry } from 'entities/jackpot';
import { accountPageJackpotModel } from '../../model';
import cls from './account-page-jackpot.module.scss';

const AddJackpotModal = createAddJackpotModal(accountPageJackpotModel.addJackpotModel);

const DeleteJackpotModal = createDeleteJackpotModal(accountPageJackpotModel.deleteJackpotModel);

const EditJackpotModal = createEditJackpotModal(accountPageJackpotModel.editJackpotModel);

const BlockJackpotModal = createBlockJackpotModal(accountPageJackpotModel.blockJackpotModel);

const UnblockJackpotModal = createUnblockJackpotModal(accountPageJackpotModel.unblockJackpotModel);

const JackpotRegistry = createJackpotRegistry(accountPageJackpotModel.jackpotRegistryModel);

export const AccountPageJackpot = () => (
	<>
		<JackpotRegistry
			withTitle={false}
			withAccount={false}
			emptyActionSlot={<AddJackpotModal.Button />}
			topBarActionSlot={<AddJackpotModal.Button />}
			tableTdActionSlot={(jackpot) => (
				<div className={cls.accountPageJackpotActions}>
					<EditJackpotModal.ActionIcon modalData={jackpot} />
					{jackpot.isLocked ? (
						<UnblockJackpotModal.ActionIcon modalData={jackpot} />
					) : (
						<BlockJackpotModal.ActionIcon modalData={jackpot} />
					)}
					<DeleteJackpotModal.ActionIcon modalData={jackpot} />
				</div>
			)}
		/>
		<AddJackpotModal />
		<EditJackpotModal />
		<BlockJackpotModal />
		<UnblockJackpotModal />
		<DeleteJackpotModal />
	</>
);
